import { create } from "zustand";

/** PostMessage payload (`ptNotificationProps`); uses subObjectRecords only. */
export type NotificationMessagePostPayload = {
  paModuleId: number;
  paObjectId: string;
  callActivityDefinitionId?: string;
  subObjectRecords: {
    objectId: string;
    moduleId: number;
  }[];
};

/** Shape passed to NotificationContent (mapped from subObjectRecords). */
export type NotificationSubAssociations = {
  subObjectId: string;
  subModuleId: number;
}[];

/** Includes subAssociations for NotificationContent indexed access; not sent via postMessage. */
export interface NotificationMessagePayload {
  paObjectId: string;
  callActivityDefinitionId?: string;
  subObjectRecords: {
    objectId: string;
    moduleId: number;
  }[];
}

export interface NotificationMessagePayload {
  subAssociations: NotificationSubAssociations;
}

export const mapSubObjectRecordsToSubAssociations = (
  records: NotificationMessagePostPayload["subObjectRecords"]
): NotificationSubAssociations =>
  records.map(({ objectId, moduleId }) => ({
    subObjectId: objectId,
    subModuleId: moduleId,
  }));

type NotificationStore = {
  notificationData?: NotificationMessagePostPayload;
  setNotificationData: (data: NotificationMessagePostPayload) => void;
};

export const useNotificationStore = create<NotificationStore>((set) => ({
  notificationData: undefined,
  setNotificationData(data) {
    set(() => ({ notificationData: data }));
  },
}));
